import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Loader2, UserPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { api } from '@/lib/api';
import { useAuthStore } from '@/lib/auth';
import { toast } from 'sonner';
import { Logo } from '@/components/Logo';
import Seo from '@/components/Seo';

export default function RegisterPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const setAuth = useAuthStore(s => s.setAuth);
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/auth/register', { name, email, phone, password });
      setAuth(res.data.access_token, res.data.user);
      toast.success('Registrazione completata!');
      nav('/');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Registrazione fallita');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[--brand-cream] noise-bg">
      <Seo title="Registrati" description="Crea il tuo account cliente MōMA • Pokè." path="/register" noindex />
      <div className="max-w-md mx-auto px-4 py-10">
        <Link to="/" className="flex items-center gap-2 mb-6">
          <Logo variant="compact" />
        </Link>

        <div className="rounded-2xl bg-white border border-[--brand-border] p-6 shadow-[var(--shadow-sm)]">
          <h1 className="font-display text-2xl font-bold">Registrati</h1>
          <p className="text-sm text-[--brand-muted] mt-1">Crea il tuo account cliente</p>

          <form onSubmit={onSubmit} className="space-y-3 mt-4">
            <div><Label>Nome</Label><Input required value={name} onChange={e => setName(e.target.value)} className="rounded-xl" data-testid="register-name-input"/></div>
            <div><Label>Email</Label><Input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="rounded-xl" data-testid="register-email-input"/></div>
            <div><Label>Telefono</Label><Input value={phone} onChange={e => setPhone(e.target.value)} className="rounded-xl" data-testid="register-phone-input"/></div>
            <div><Label>Password (min 6 caratteri)</Label><Input type="password" required minLength={6} value={password} onChange={e => setPassword(e.target.value)} className="rounded-xl" data-testid="register-password-input"/></div>
            <Button type="submit" disabled={loading} className="w-full rounded-xl bg-[--brand-primary] hover:bg-[--brand-primary-hover]" data-testid="register-submit-button">
              {loading ? <Loader2 size={16} className="animate-spin"/> : <><UserPlus size={16} className="mr-2"/>Crea account</>}
            </Button>
          </form>
          <p className="text-sm text-[--brand-muted] mt-4 text-center">
            Hai già un account? <Link to="/login" className="text-[--brand-primary] font-semibold hover:underline">Accedi</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
